import React, { useEffect, useMemo, useState } from 'react';
import { Icon, Image, Placeholder } from 'react-frontier';
import { CDN_URL } from '../API';
import { ListPosting } from '../Classes';
import { Link } from 'react-router-dom';
import { addCommas } from '@tempu/components/Util';
import { getDurationTime } from '../Util';
import moment from 'moment';

interface PostingItemProps{
	posting?: ListPosting,
	to?: string,
	placeholder?: boolean,
}

var PostingItem = (props: PostingItemProps)=>{
	var posting_time = useMemo(()=>{
		if(!props?.posting) return null;
		var time = getDurationTime(props.posting.date_start, props.posting.date_end);
		return ` (${time})`;
	}, [props.posting])

	if(props.placeholder){
		return <div className="tp posting item placeholder">
			<div className="image"></div>
			<div className="info">
				<Placeholder className='name' height={20} minWidth={120} />
				<Placeholder className='meta' height={15} minWidth={50} width={50} style={{ marginTop: 15 }} />
				<Placeholder className='meta' height={15} minWidth={30} width={30} style={{ marginTop: 10 }} />
			</div>
			<div className="details">
				<Placeholder className='name' height={20} width={40} />
				<Placeholder className='name' height={20} width={40} style={{ marginTop: 10 }} />
			</div>
		</div>
	}

	if(!props.posting) return null;

	return <Link className="tp posting item" to={props.to}>
		<div className="image">
			<Image src={`${CDN_URL}/posting/${props.posting.posting_id}/small.webp`} fallbackComponent={(
				<i className='image icon' />
			)} />
		</div>
		<div className="info">
			<div className="name">{props.posting.posting_name}</div>
			<div className="meta">
				{moment.unix(props.posting.date_start).format('DD/MMM/YYYY')}
				{posting_time}
			</div>
			<div className="meta" style={{ marginTop: 5 }}>{props.posting.business_name}</div>
			<div className="meta">{props.posting.city + ', ' +props.posting.state}</div>
		</div>
		<div className="details">
			<div className="rate">
				<i className="dollar icon"></i>
				{addCommas(props.posting.min_pay_rate)}
				{props.posting.max_pay_rate>props.posting.min_pay_rate && <>
					<Icon name='minus' style={{ marginRight: 1 }} />
					{addCommas(props.posting.max_pay_rate)}
				</>}
			</div>
			<div className="distance">
				<i className="map marker alternate icon"></i>
				{props.posting.distance ? (
					`~${props.posting.distance.toFixed(2)} km`
				) : props.posting.location_name ? (
					props.posting.location_name	
				) : (
					props.posting.city
				)}
			</div>
		</div>
	</Link>
}

export default PostingItem;